import { render } from "./SettingCom.vue?vue&type=template&id=9b95a120&scoped=true"
import script from "./SettingCom.vue?vue&type=script&lang=js"
export * from "./SettingCom.vue?vue&type=script&lang=js"

import "./SettingCom.vue?vue&type=style&index=0&id=9b95a120&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b95a120"]])

export default __exports__